const EntryRoute = [
  {
    path: '',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Home/Entry/Entry.vue'),
    meta: { transitionName: 'slide-right' },
  },
];
export default EntryRoute;
